import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        login: null,
        shopid: null,
        nav_name: null,
        page_name: null
    },
    getters: {

        page_name:function(state) {
            return state.page_name
        },
        nav_name:function(state) {
            return state.nav_name
        },
        login:function(state) {
            return state.login
        },
        shopid:function(state) {
            return state.shopid
        },
    },
    mutations: {
        page_name (state, v) {
            state.page_name = v
        },
        nav_name (state, v) {
            state.nav_name = v
        },
        login (state, v) {
            state.login = v
        },
        shopid (state, v) {
            state.shopid = v
        },
    },
    actions: {
        page_name ({commit}, v) {
            commit('page_name', v)
        },
        nav_name ({commit}, v) {
            commit('nav_name', v)
        },
        login ({commit}, v) {
            commit('login', v)
        },
        shopid ({commit}, v) {
            commit('shopid', v)
        },
    }
})